import React, { useEffect } from "react";
import { TutorProvider } from "../context/AiTutorContext";
import { DoubtProvider } from "../context/DoubtContext";
import Doubt from "../pages/ai-tutor/Doubt/Doubt";
import { useRoot } from "../context/RootContext";
import { useLocation } from "@remix-run/react";
import { StorageService } from "../utils/StorageUtils";
export let loader = async () => {
  return { type: "doubt" };
};
export default function DoubtPage() {
  const location = useLocation();
  const {
    subject,
    subjectMasterUuid,
    topic,
    topicMasterUuid,
    subjectName,
    topicName,
  } = location.state || " ";
  const {
    setSelectedIndex,
    setTaskTypeName,
    setSubTopicName,
    setTopicName,
    setSubjectName,
    setTaskCatagory,
    isStandalone,
  } = useRoot();
  useEffect(() => {
    setSelectedIndex(2);
    if (subjectName) {
      setSubjectName(subjectName);
    }
    if (topicName) {
      setTopicName(topicName);
    }
    StorageService.removeItem("assesmentInfo");
    if (typeof window !== "undefined") {
      window.history.replaceState(null, "", window.location.href);
    }
    // setTaskTypeName("");
    // setSubTopicName("");
    // setTopicName("");
    // setSubjectName("");
    // setTaskCatagory("");
  }, []);
  return (
    <TutorProvider>
      <DoubtProvider>
        <Doubt
          subject={subject}
          topic={topic}
          subjectMasterUuid={subjectMasterUuid}
          topicMasterUuid={topicMasterUuid}
          subjectName={subjectName}
          topicName={topicName}
        />
      </DoubtProvider>
    </TutorProvider>
  );
}
